module.exports = __webpack_public_path__ + "img/email.1939b8f8.svg";